import { isAiTextTo3dEnabled } from "./config/aiTextTo3d";
import { XANO_BASE, API_DEFAULT, API_AUTH, API_ASSETS, API_STRIPE, API_LIBRARY } from "./config/xano";

// SIGN UP A NEW USER
export const sendNewUser = (
  data,
  url = API_DEFAULT + '/auth/signup'
) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: Math.random().toString(16).slice(2),
      created_at: data.created_at,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
      projects: ['']
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
};

// DELETE A USER AND STRIPE/AUTH0/GOOGLE/FIGMA INTS AND ASSOCIATED PROJECTS/IMAGES/MODELS/FIGMAS
export const deleteUserAndSubs = (
) => {
  return fetch(API_DEFAULT + '/user', {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}

// LOGIN AN EXISTING USER
export const sendUserLogin = (
  data,
  url = API_DEFAULT + '/auth/login'
) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: data.email,
      password: data.password
    })
  })
    .then((response) => response.json())
    .then((data) => {return data})
    .catch((error) => {
      console.error("Error:", error);
    });
}
// GET AUTH0 CONVERTED TOKEN FROM XANO 
export const getAuth0Token = (data
  ) => {           
    return fetch(API_AUTH + '/oauth/auth0/continue?code=' + data.code + '&redirect_uri=' + data.redirect_uri, {
      method: 'GET',
      headers: {
        "content-type": "application/json"
        // "Authorization": `Bearer ${localStorage.getItem("user")}`
      }
      // body: JSON.stringify({
      //   code: data.code,
      //   redirect_uri: data.uri
      // })
    })
      .then((response) =>
        response.json()
      )
      .then((data) => {
        // console.log(data)
        // localStorage.setItem('user',data.token)
        return data
      })
      .catch((error) => {
        return error
      });
  }
// GET AUTH0 LOGIN URL
export const getAuth0URL = (data
  ) => {
    return fetch(API_AUTH + '/oauth/auth0/init' +'?redirect_uri='+data, {
      method: 'GET',
      headers: {
        "content-type": "application/json"
        // "Authorization": `Bearer ${localStorage.getItem("user")}`
      }
      // body: JSON.stringify({
      //   code: data.code,
      //   redirect_uri: data.uri
      // })
    })
      .then((response) =>
        response.json()
      )
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      });
  }

// VALIDATE USER AUTH TOKEN
export const checkAuthToken = () => {
  return fetch(API_DEFAULT + '/auth/me', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("user")}`
    },
  })
    .then((response) =>
      response.json()
    )
    .then((data) => {
      return data
    })
    .catch((error) => {
      
      return error
    });
}

// VALIDATE USER AUTH TOKEN AND SUBSCRIPTION
export const checkAuthTokenAndSubscription = () => {
  return fetch(API_STRIPE + '/auth/subscription', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("user")}`
    },
  })
    .then((response) =>
      response.json()
    )
    .then((data) => {
      return data
    })
    .catch((error) => {
      
      return error
    });
}

// CREATE A NEW PROJECT
export const createNewProjectRecord = (
  data
) => {
  return fetch(API_DEFAULT + '/project_with_key', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectName: data.name,
      projectKey: data.projectKey
    })
  })
}


// GET ALL A USER'S PROJECTS
export const getUserProjectsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${data}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}



// GET ALL PROJECTS A USER IS A GUEST TO
export const getUserAccount = (
  data
) => {
  return fetch(API_DEFAULT + '/user/', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}



// GET ALL PROJECTS A USER IS A GUEST TO
export const getGuestProjectsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/user/sharedProjects', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}

// ADD NEW USER' GUEST PROJECTS (is link correct?)
export const setGuestProjectsAPI = (
  data
) => {
  return fetch(`${API_DEFAULT}/user/${data.userEmail}`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      userEmail: data.userEmail,
      projectKey: data.projectKey
    })
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}
// REMOVE A USER GUEST PROJECT
export const deleteGuestProjectsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/user/guestProject/delete', {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      userEmail: data.userEmail,
      projectKey: data.projectKey
    })
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}


// GET SPECIFIC PROJECT
export const getSpecificUserProjectAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
      // "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data === 404) {
        window.location.href = "/404"
      return } else {
      return data }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response.status == 404) {
        window.location.href = "/404";
        return;
      }
    });
}

// GET SPECIFIC PROJECT SIGNEDOUT
export const getSpecificUserProjectGuestAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/projectGuest/' + data, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      // "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response.status == 404) {
        window.location.href = "/404";
        return;
      }
    });
}

// GET PROJECT GUEST PREVIEW STATE
export const getSpecificUserProjectGuestAccessAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/projectAccessBool/' + data, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      // "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data === 404) {
        window.location.href = "/404"
      return } else {
      return data }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response.status == 404) {
        window.location.href = "/404";
        return;
      }
    });
}

// SET PROJECT GUEST PREVIEW STATE
export const setSpecificUserProjectGuestAccessAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data.projectKey + '/setGuestAccess', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      loggedOutGuestAccess: data.loggedOutGuestAccess
    })
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response.status == 404) {
        window.location.href = "/404";
        return;
      }
    });
} 

// GET PROJECT GUESTS
export const getProjectGuestsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data + '/guests', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
      if (error.response.status == 404) {
        window.location.href = "/404";
        return;
      }
    });
}

// DELETE SPECIFIC PROJECT
export const deleteSpecificUserProjectAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data, {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// SAVE PROJECT
export const saveUserProjectAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data.projectKey, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      project_id: data.projectKey,
      projectName: data.projectName,
      projectUserName: data.projectUserName,
      projectUserActivity: data.projectUserActivity,
      projectUserOutcome: data.projectUserOutcome,
      artboards: data.artboards,
      storyboardFields: data.storyboardFields,
      floorColour: data.floorColour,
      projectKey: data.projectKey,
    })

  })
    .then((response) => response.json())
    .then((data) => {
      try {
        if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof CustomEvent !== "undefined") {
          window.dispatchEvent(
            new CustomEvent("matchboxxr:projectSaved", {
              detail: Date.now(),
            })
          );
        }
      } catch (e) {
        // Footer should never break saving; ignore.
      }
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// UPDATE OBJECT FIELD
export const saveObjectUpdate = (
  data
) => {
  return fetch(API_DEFAULT + '/object/update', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      artboard: data.artboard,
      objectID: data.objectID,
      field: data.field,
      data: data.data
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// ADD OBJECT TO ARTBOARD
export const saveObjectAdd = (
  data
) => {
  return fetch(API_DEFAULT + '/object/add', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      artboard: data.artboard,
      object: data.object
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data 
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// DELETE OBJECT FROM ARTBOARD
export const saveObjectDelete = (
  data
) => {
  return fetch(API_DEFAULT + '/object/delete', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      artboard: data.artboard,
      objectID: data.objectID
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// SAVE PROJECT GUESTS ONLY
export const saveUserGuestsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data.projectKey + '/projectGuests', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      delete: data.delete,
      projectKey: data.projectKey,
      newUser: data.newUser
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}




// SAVE PROJECT ARTBOARDS ONLY
export const saveUserArtboardsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/project/' + data.projectKey, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      project_id: data.projectKey,
      artboards: data.artboards,
      projectKey: data.projectKey,
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// SAVE PROJECT SCREENSHOTS ONLY
export const saveUserScreenshotsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/projectScreenshot/' + data.projectKey, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      screenshots: data.screenshots
    })
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.log(error)
      return error
    });
}

//GET PROJECT SCREENSHOTS
export const getProjectScreenshots = (
  data 
) => {
  return fetch(`${API_DEFAULT}/project/${data}/screenshots`, {
    method: 'GET',
    headers: {
      "content-type": "application/json"
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


 
//GET SPECIFIC AI MODEL VIA ID
export const getSpecificAIModel = (
  data 
) => {
  // return fetch(API_ASSETS + '/ai?id=' + data, {
  return fetch(API_ASSETS + '/ai_model/single/?id=' + data, {
    method: 'GET',
    headers: {
      "content-type": "application/json"
      // "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET USER'S AI MODELS
export const getUserAIModels = (
  data
) => {
  if (!isAiTextTo3dEnabled()) {
    return Promise.resolve([]);
  }
  return fetch(API_ASSETS + '/ai_model', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// GET ALL AI MODELS
export const getAllAIModels = (
  data
) => {
  if (!isAiTextTo3dEnabled()) {
    return Promise.resolve([]);
  }
  return fetch(API_ASSETS + '/ai_model/all', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// GET USER'S AI QUOTA
export const getUserAIQuota = (
  data
) => {
  if (!isAiTextTo3dEnabled()) {
    return Promise.resolve(0);
  }
  return fetch(API_DEFAULT + '/user/ai_quota', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// SEND MODEL PROMPT FOR OPENAI
export const sendAIModelPrompt = (
  data 
) => {
  if (!isAiTextTo3dEnabled()) {
    return Promise.reject(new Error("AI_TEXT_TO_3D_DISABLED"));
  }
  return fetch(API_ASSETS + '/ai_model/tripo', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      prompt: data
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// OLD MESHY SEND MODEL PROMPT FOR OPENAI
export const oldSendAIModelPrompt = (
  data
) => {
  return fetch(API_ASSETS + '/ai_model', {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      prompt: data
    })

  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// DELETE SPECIFIC AI MODEL
export const deleteSpecificAIModel = (
  data
) => {
  if (!isAiTextTo3dEnabled()) {
    return Promise.resolve("unavailable");
  }
  return fetch(API_ASSETS + '/ai_model/' + data, {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}





//GET SPECIFIC UPLOADED MODEL VIA ID
export const getSpecificUploadModel = (
  data
) => {
  return fetch(API_DEFAULT + '/model/' + data, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET USER'S AI PERMISSIONS
export const getUserHasAI = (
  data
) => {
  return fetch(API_DEFAULT + '/user/', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data.hasAI
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// POST FIGMA KEY TO XANO TO STORE (LASTS 90 DAYS)
export const postFigmaPersonalKey = (
  data
) => {
  return fetch(API_DEFAULT + "/editFigmaKey",
  {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      figmaKey: data.figmaKey
    })
  })
}

// POST FIGMA KEY TO XANO TO STORE (LASTS 90 DAYS)
export const postMiroPersonalKey = (
  data
) => {
  return fetch(API_DEFAULT + "/editMiroKey",
  {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      miroKey: data.miroKey
    })
  })
}
 
// POST FIGMA AUTH DATA FOR PERMISSION TOKEN & SEND TO XANO
export const postFigmaAuthData = (
  data
) => {
  return fetch(
    API_DEFAULT + "/figmaGetAccessToken"
  , {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      code: data.code
    })

  })
  .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}
// POST MIRO AUTH DATA FOR PERMISSION TOKEN & SEND TO XANO
export const postMiroAuthData = (
  data
) => {
  return fetch(
    "https://api.miro.com/v1/oauth/token" 
    + "&grant_type=" + data.grantType
    + "?client_id=" + data.clientID
    + "&client_secret=" + data.clientSecret
    + "&code=" + data.code
    + "&redirect_uri=" + data.callbackURI
  , {
    method: 'POST',
    headers: {
      'Origin': 'https://mbxr.io',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }

  })
  .then((response) => response.json())
  .then((data) => {
    postMiroPersonalKey({miroKey: data.access_token, user: localStorage.getItem('user')})
  })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// ADD FIGMA FRAME TO XANO FROM LINK
// NEED CONDITIONAL TO MAKE SURE WE DON'T ADD IT TWICE IF IT EXISTS, JUST EDIT EXISTING
export const addFigmaFrameFromLink = (
  data
) => {
  return fetch(`${API_DEFAULT}/figmaframes`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      frameID: data.frameID,
      fileID: data.fileID
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}



// UPDATE FIGMA TO LATEST THUMBNAIL
export const updateFigmaFromID = (
  data
) => {
  return fetch(`${API_DEFAULT}/figmaframes/${data}`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET FIGMA FRAME FROM IMAGE LINK
export const getFigmaFrameFromLink = (
  data
) => {
  return fetch(`https://api.figma.com/v1/images/sO1XQpnEnmQvYLzNFozPPE?ids=208-556`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('figmaAuthToken')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // console.log(data.images)
      localStorage.setItem('figmaImage', data.images['208:556'])
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// CHECK FIGMA FRAME FROM IMAGE LINK
export const isFigmaFrameMine = (
  data
) => {
  return fetch(`${API_DEFAULT}/figmaframes/${data}/isMine`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET FIGMA FRAME FROM ID
export const getFigmaFrameFromID = (
  data
) => {
  return fetch(`${API_DEFAULT}/figmaframes/${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET ALL USER'S FIGMA FRAME URLS FROM TABLE
export const getUserFigmaFramesAPI = () => {
  return fetch(API_DEFAULT + '/figmaframes', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET USER'S TEAM'S PROJECTS 
export const getTeamFigmaProjects = (
  data
) => {
  return fetch(API_DEFAULT + '/figmaframes', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// CHECK IF VALID FIGMA KEY EXITS
export const checkForValidFigmaKey = (
  data
) => {
  return fetch(API_DEFAULT + '/user/hasFigmaKey', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


//DELETE FIGMA FRAME
export const deleteFigmaFrameFromAccount = (
  data
) => {
  return fetch(API_DEFAULT + '/figmaframes/' + data, {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}
//DELETE FIGMA SYNC
export const deleteFigmaSync = (
  data
) => {
  return fetch(API_DEFAULT + '/figmasync', {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}


// GET INITIAL FIGMA AUTH URL
export const getFigmaAuthURL = (
  data
) => {
  return fetch(`${API_DEFAULT}/getFigmaAuthURL?rando=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}



// CHECK FOR MIRO ENTRY
export const getMiroSyncEntry = (
  data
) => {
  return fetch(API_DEFAULT + '/mirosync/haveEntry', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}




// REMOVE A USER miro integration
export const deleteUserMiroEntry = (
  data
) => {
  return fetch(API_DEFAULT + '/mirosync/deleteEntry', {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}


// CHECK FOR Google Slides ENTRY
export const getGoogleSyncEntry = (
  data
) => {
  return fetch(API_DEFAULT + '/googleSync/haveEntry', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}



// GET MIRO BOARD
export const getMiroBoard = (
  data
) => {
  return fetch(`${API_DEFAULT}/getMiroBoard?boardId=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET USER'S MIRO FRAMES
export const getUserMiroFrames = (
  data
) => {
  return fetch(`${API_DEFAULT}/getMiroFramesByBoard?boardId=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET USER'S Google SLides
export const getUserGoogleSlides = (
  data
) => {
  return fetch(API_DEFAULT + '/getGoogleSlidesByUser', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET USER'S Google Slides thumbnail and length
export const getUserGoogleSlidesThumbAndLength = (
  data
) => {
  return fetch(`${API_DEFAULT}/getGoogleSlidePages/${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// REMOVE A USER Google Slides integration
export const deleteUserGoogleEntry = (
  data
) => {
  return fetch(API_DEFAULT + '/googlesync', {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}

export const sendStoryboardToMiro = (data
  ) => {
    return fetch(API_DEFAULT + '/CreateMiroStoryboard', {
      method: 'POST',
      headers: {
        "content-type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem('user')}`
      },
      body: JSON.stringify({
          boardId: data.boardId,
          projectKey: data.projectKey,
          frameId: data.frameId
        })
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        return data
      })
      .catch((error) => {
        console.error("Error:", error);
  
      });
  }

// export to google slides
export const exportToGSlides = (
  data
) => {
  return fetch(`${API_DEFAULT}/exportToSlide`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      presentationID: data.presentationID,
      index: data.index,
      projectKey: data.projectKey
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
} 

// GET INITIAL GOOGLE AUTH URL
export const getGoogleAuthURL = (
  data
) => {
  return fetch(`${API_DEFAULT}/getGoogleAuthURL?projectKey=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET INITIAL MIRO AUTH URL
export const getMiroAuthURL = (
  data
) => {
  return fetch(`${API_DEFAULT}/getMiroAuthURL?projectKey=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET GOOGLE PICKER CREDENTIALS
export const getGooglePickerCreds = (
  data
) => {
  return fetch(`${API_DEFAULT}/getGooglePickerCreds`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET USER'S STRIPE SUBSCRIPTION STATUS
export const getStripeSubStatus = (
) => {
  return fetch(`${API_STRIPE}/subscription_status`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}



// GET STRIPE CHECKOUT URL
export const getStripeCheckoutURL = (
  data
) => {
  return fetch(`${API_STRIPE}/sessions`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      success_url: data.success_url,
      cancel_url: data.cancel_url,
      subscription: data.subscription
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET ALL POSES FOR A SPECIFIC MODEL
export const getPoses = ( 
  data
) => {
  return fetch(`${API_LIBRARY}/preset_model_file?object=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// GET SINGLE POSE
export const getSinglePose = ( 
  data
) => {
  return fetch(`${API_LIBRARY}/preset_model_file/${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }, 
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// GET MODEL URLS
export const getModelURLs = ( 
  data
) => {
  return fetch(`${API_DEFAULT}/project/${data}/model_urls`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// GET TEMPLATE SCENES BY CATEGORY
export const getTemplateScenes = ( 
  data
) => {
  return fetch(`${API_LIBRARY}/template_scenes?category=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// TEST FIGMA FRAME WORKS
export const testFigmaFrame = ( 
  data
) => {
  return fetch(data, {
    method: 'GET',
    headers: {
      "content-type": "application/json"
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// CHECK WHAT TUTORIALS HAVE BEEN SEEN
export const checkTutorialSeen = ( 
  data
) => {
  return fetch(API_DEFAULT + '/user/tutorial_seen', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// UPDATE WHAT TUTORIALS HAVE BEEN SEEN
export const updateTutorialSeen = ( 
  data
) => {
  return fetch(API_DEFAULT + '/user/edit_tutorial_seen', {
    method: 'PUT',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      tutorialPage: data.tutorialPage,
      tutorialSeen: data.tutorialSeen
    })
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// POST NEW THREAD
export const postNewThread = (
  data
) => {
  return fetch(`${API_DEFAULT}/threads`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      artboard: data.artboard,
      position: data.position
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}


// GET THREADS
export const getThreads = ( 
  data
) => {
  return fetch(`${API_DEFAULT}/threads?projectKey=${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}



// POST NEW THREAD
export const postNewComment = (
  data
) => {
  return fetch(`${API_DEFAULT}/comments`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
    body: JSON.stringify({
      projectKey: data.projectKey,
      threads_id: data.threads_id,
      comment_content: data.comment_content
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
} 


// GET COMMENTS
export const getComments = ( 
  data
) => {
  return fetch(`${API_DEFAULT}/comments/${data}`, {
    method: 'GET',
    headers: {
      "content-type": "application/json"
    },
  }) 
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}


// POST NEW REALTIME TOKEN
export const postRealtimeToken = (
) => {
  return fetch(`${API_DEFAULT}/realtime_token`, {
    method: 'POST',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}


// DELETE REALTIME TOKEN
export const deleteRealtimeToken = (
  data
) => {
  return fetch(`${API_DEFAULT}/realtime_token/${data}`, {
    method: 'DELETE',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error:", error);
    });
}

